import { encodeBase64 } from "../../utils/utilityFunctions"
import { CALL_API } from "../middleware"
import { EDIT_INVESTMENT_ERROR_DETAILS, EDIT_INVESTMENT_VALUE_DETAILS, GetSchemeDataResponseType, INITIAL_DATA, InvestmentFormType, REMOVE_INVESTMENT_DATA } from "../types/investmentdetails"
import { GET_SCHEMES_TABLE_DATA, GET_SCHEMES_TABLE_DATA_SUCCESS, GetSchemesTableDataRequestBody } from "../types/investorProfile"


export const FormValueInvestment = (body: any) => {
    return {
        type: EDIT_INVESTMENT_VALUE_DETAILS,
        body
    }
}
export const FormErrorInvestment = (body: any) => {
    return {
        type: EDIT_INVESTMENT_ERROR_DETAILS,
        body
    }
}

export const RemoveInvestmentData = (schemId: string | number, initialValue: InvestmentFormType) => {

    // let body
    const filteredValue = Object.values(initialValue.value).filter((val) => val.schemeId !== schemId);
    const filteredError = Object.values(initialValue.error).filter((val) => val.schemeId !== schemId);
    return {
        type: REMOVE_INVESTMENT_DATA,
        body: {
            value: { ...filteredValue },
            error: { ...filteredError }
        }
    }
}

export const InitialData = () => {
    return {
        type: INITIAL_DATA,
        body: {}
    }
}

export const getSchemeData =
    (body: GetSchemesTableDataRequestBody) =>
        async (dispatch: any): Promise<GetSchemeDataResponseType> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/search/schemes`,
                    method: 'POST',
                    types: [GET_SCHEMES_TABLE_DATA_SUCCESS, GET_SCHEMES_TABLE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
